module.exports = __webpack_public_path__ + "static/media/Q1_Front_Right.eebee664.png";